module.exports = __webpack_public_path__ + "static/img/35ba065d1adbfec1a3114e75d49d8d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon4.png
// module id = 9Yoi
// module chunks = 1